import { render, staticRenderFns } from "./player-activity.vue?vue&type=template&id=46d09638"
import script from "./player-activity.vue?vue&type=script&lang=js"
export * from "./player-activity.vue?vue&type=script&lang=js"
import style0 from "./player-activity.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/player-activity.vue
// module id = 7oIc
// module chunks = 0